import { styled } from "@monolith-forensics/monolith-ui";
import { WebHook, WebhookList } from "@/Features";
import { useGetWebhook } from "@/Features/Webhooks/webhooks.query";
import { ApiKeyList, useGetApiKeys } from "@/Features/ApiKeys";

export const WebHooks: WebHook[] = [
  {
    name: "Test Hook",
    description: "This is a test webhook",
    url: "https://monolith-staging.monolithforensics.com/api/v1/info",
    enabled: true,
    secret: "monolith_wh_G0ezr4BpjIcm5F9VbGiEjxojEhB93KtfPvhYAVNuKJLy",
    events: ["cases", "evidence"],
    id: 1,
    uuid: "d4e8f2c1-5b4e-4f7c-8a3d-6f3e5c1b1a2a",
    created_by: {
      user_id: 1,
      full_name: "Matt Danner",
      email: "matt@monolithforensics.com",
    },
    created_on: "2023-10-01T12:00:00Z",
    updated_on: "2023-10-01T12:00:00Z",
  },
  {
    name: "Test Hook 2",
    description: "This is a test webhook",
    url: "https://monolith-staging.monolithforensics.com/api/v1/info",
    enabled: true,
    secret: "monolith_wh_KAD9a8hadf0872nvsh8kjsnjJSFJSA9af9s",
    events: ["cases", "evidence"],
    id: 2,
    uuid: "d4e8f2c2-5b4e-4f7c-8a3d-6f3e5c1b1a2a",
    created_by: {
      user_id: 1,
      full_name: "Matt Danner",
      email: "matt@monolithforensics.com",
    },
    created_on: "2023-10-01T12:00:00Z",
    updated_on: "2023-10-01T12:00:00Z",
  },
];

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  max-width: 700px;
  gap: 20px;

  flex: 1 1 auto;
  height: 0px;
  overflow: auto;
`;

const StyledTitle = styled.h2``;

const StyledH4 = styled.h4`
  margin: 5px 0px;
  font-weight: 600;
`;

const StyledDescription = styled.p`
  margin: 0px;
  line-height: 1.5;
  color: ${(props) => props.theme.palette.text.secondary};
`;

const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ContentBlock = styled.div``;

const ApiKeyContent = () => {
  const { data } = useGetApiKeys();

  const apiKeys = data?.data || [];

  return (
    <ContentBlock>
      <StyledH4>API Key Management</StyledH4>
      <StyledDescription style={{ marginBottom: 10 }}>
        API keys are used to authenticate requests to the Monolith API. You can
        create, revoke, and manage your API keys from this page. Make sure to
        keep your API keys secure and do not share them with anyone.
      </StyledDescription>
      <ApiKeyList data={apiKeys} />
    </ContentBlock>
  );
};

const WebhooksContent = () => {
  const { data } = useGetWebhook();

  const webhooks = data?.data || [];

  return (
    <ContentBlock>
      <StyledH4>Webhooks</StyledH4>
      <StyledDescription style={{ marginBottom: 10 }}>
        Webhooks allow you to receive HTTP requests when a Monolith resource is
        created, updated, or deleted.
      </StyledDescription>
      <WebhookList data={webhooks} />
    </ContentBlock>
  );
};

export const APIPage = () => {
  return (
    <StyledContent>
      <ContentBlock>
        <StyledTitle>API</StyledTitle>
        <StyledDescription>
          The API is a powerful tool that allows you to interact with the
          Monolith platform programmatically. You can use it to automate tasks,
          integrate with other systems, and build custom applications.
        </StyledDescription>
      </ContentBlock>
      <StyledBody>
        <ApiKeyContent />
        <WebhooksContent />
      </StyledBody>
    </StyledContent>
  );
};
